import { render } from "./Buy.vue?vue&type=template&id=020aae62&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"

import "./Buy.vue?vue&type=style&index=0&id=020aae62&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020aae62"]])

export default __exports__